import { createSlice } from "@reduxjs/toolkit";

const getCartDetails = () => {
  const data = localStorage.getItem("cart");
  let cart = [];
  if (!data) {
    localStorage.setItem("cart", JSON.stringify([]));
  } else cart = JSON.parse(data);
  return cart;
};

const saveCartDetails = (data) => {
  localStorage.setItem("cart", JSON.stringify(data));
};

export const counterSlice = createSlice({
  name: "counter",
  initialState: {
    products: getCartDetails(),
  },
  reducers: {
    addToCart: (state, action) => {
      const index = state.products.findIndex(
        (item) => item.product.prodId == action.payload.product.prodId
      );
      if (index > -1) {
        state.products[index].quantity += parseInt(action.payload.quantity);
      } else state.products.push(action.payload);
      saveCartDetails(state.products);
      return state;
    },
    removeFromCart: (state, action) => {
      
      const updateIndex = state.products.findIndex(
        (item) => item.product.prodId == action.payload.product.prodId
      );
      if (updateIndex > -1) {
        if (state.products[updateIndex].quantity > 1)
          state.products[updateIndex].quantity -= parseInt(
            action.payload.quantity
          );
        else state.products.splice(updateIndex, 1);
      }
      saveCartDetails(state.products);
      return state;
    },
    clearCart: (state, action) => {
      state.products = [];
      saveCartDetails(state.products);
      return state;
    },
  },
});

export const { addToCart, removeFromCart, clearCart } = counterSlice.actions;
export default counterSlice.reducer;
